import { render, staticRenderFns } from "./CatalogPreviewInfo.vue?vue&type=template&id=311af345&scoped=true&"
import script from "./CatalogPreviewInfo.vue?vue&type=script&lang=js&"
export * from "./CatalogPreviewInfo.vue?vue&type=script&lang=js&"
import style0 from "./CatalogPreviewInfo.vue?vue&type=style&index=0&id=311af345&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311af345",
  null
  
)

export default component.exports